export const loadState = () => {
  try {
    const authState = localStorage.getItem("person");
    const languageState = localStorage.getItem("language");
    // const links = localStorage.getItem("links");

    return {
      auth: authState ? JSON.parse(authState) : undefined,
      language: {
        language: languageState ? parseInt(languageState, 10) : 1,
      },
      // links: links ? JSON.parse(links) : undefined,
    };
  } catch (err) {
    console.error("Error loading state:", err);
    return undefined;
  }
};


export const saveState = (state) => {
  try {
    // Save auth state
    localStorage.setItem("person", JSON.stringify(state.auth));
    // Save language state
    localStorage.setItem("language", state.language.language.toString());
    // Save links state
    // localStorage.setItem("links", JSON.stringify(state.links));
  } catch (err) {
    console.error("Error saving state:", err);
  }
};
